// components/UserLogin.js
import React from "react";
import "./UserLogin.css";

function UserLogin({ onGoogleLogin }) {
  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <h1>Iniciar Sesión</h1>
          <p>Accede a tu cuenta de Espacio Paradigmas</p>
        </div>

        <div className="login-options">
          <div className="google-login-section">
            <h3>Continuar con Google</h3>
            <p className="login-description">
              Usa tu cuenta de Google para acceder a todas las funciones.
            </p>

            <button onClick={onGoogleLogin} className="google-login-btn">
              <span className="google-icon">G</span>
              <span>Continuar con Google</span>
            </button>
          </div>

          <div className="login-info">
            <h4>¿Por qué iniciar sesión?</h4>
            <ul>
              <li>Reservar clases y eventos</li>
              <li>Recibir recordatorios personalizados</li>
              <li>Guardar tus actividades favoritas</li>
              <li>Acceder a contenido exclusivo</li>
            </ul>
          </div>
        </div>

        {/* <div className="login-footer">
          <p>
            Al iniciar sesión, aceptas nuestros{" "}
            <a href="/terms">Términos de Servicio</a> y{" "}
            <a href="/privacy">Política de Privacidad</a>.
          </p>
        </div> */}
      </div>
    </div>
  );
}

export default UserLogin;
